import {
  NumberFormatter as MantineNumberFormatter,
  NumberFormatterProps as MantineNumberFormatterProps,
} from "@mantine/core";

const NumberFormatter = ({ ...props }: MantineNumberFormatterProps) => {
  return <MantineNumberFormatter thousandSeparator=" " {...props} />;
};

export default NumberFormatter;
